import React, { Component } from 'react';
import { PracticePin } from './PracticePin';
import { DentalPractice } from '../../types';
const mockPractices: DentalPractice[] = [
// Nord
{
  id: 'n1',
  name: 'Zahnzentrum Hamburg Hafen',
  address: 'Am Sandtorkai 48',
  city: '20457 Hamburg',
  phone: '040 1234567',
  email: 'info@zz-hamburg.de',
  employees: 12,
  territory: 'Nord',
  coordinates: {
    x: 48,
    y: 18
  }
}, {
  id: 'n2',
  name: 'Praxis Dr. Norden',
  address: 'Holstenstraße 1',
  city: '24103 Kiel',
  phone: '0431 987654',
  email: 'praxis@dr-norden.de',
  employees: 5,
  territory: 'Nord',
  coordinates: {
    x: 50,
    y: 12
  }
}, {
  id: 'n3',
  name: 'Dental Care Bremen',
  address: 'Obernstraße 45',
  city: '28195 Bremen',
  phone: '0421 555666',
  email: 'kontakt@dental-bremen.de',
  employees: 8,
  territory: 'Nord',
  coordinates: {
    x: 42,
    y: 25
  }
}, {
  id: 'n4',
  name: 'Zahnärzte am Maschsee',
  address: 'Arthur-Menge-Ufer 5',
  city: '30169 Hannover',
  phone: '0511 333444',
  email: 'team@maschsee-zahn.de',
  employees: 15,
  territory: 'Nord',
  coordinates: {
    x: 48,
    y: 30
  }
},
// Mitte
{
  id: 'm1',
  name: 'Main Tower Dentists',
  address: 'Neue Mainzer Str. 52',
  city: '60311 Frankfurt',
  phone: '069 998877',
  email: 'reception@main-dentists.de',
  employees: 22,
  territory: 'Mitte',
  coordinates: {
    x: 45,
    y: 48
  }
}, {
  id: 'm2',
  name: 'Praxis am Herkules',
  address: 'Wilhelmshöher Allee 2',
  city: '34117 Kassel',
  phone: '0561 112233',
  email: 'info@herkules-zahn.de',
  employees: 6,
  territory: 'Mitte',
  coordinates: {
    x: 47,
    y: 40
  }
}, {
  id: 'm3',
  name: 'Zahnmedizin Erfurt',
  address: 'Anger 12',
  city: '99084 Erfurt',
  phone: '0361 445566',
  email: 'kontakt@zahn-erfurt.de',
  employees: 9,
  territory: 'Mitte',
  coordinates: {
    x: 55,
    y: 45
  }
}, {
  id: 'm4',
  name: 'Leipzig Smile',
  address: 'Petersstraße 36',
  city: '04109 Leipzig',
  phone: '0341 778899',
  email: 'smile@leipzig-dent.de',
  employees: 14,
  territory: 'Mitte',
  coordinates: {
    x: 60,
    y: 42
  }
}, {
  id: 'm5',
  name: 'Ruhrpott Zähne',
  address: 'Kettwiger Str. 22',
  city: '45127 Essen',
  phone: '0201 223344',
  email: 'glueckauf@ruhr-zahn.de',
  employees: 18,
  territory: 'Mitte',
  coordinates: {
    x: 32,
    y: 38
  }
},
// Süd
{
  id: 's1',
  name: 'Zahnklinik Isartor',
  address: 'Tal 44',
  city: '80331 München',
  phone: '089 112233',
  email: 'info@isartor-klinik.de',
  employees: 35,
  territory: 'Süd',
  coordinates: {
    x: 55,
    y: 68
  }
}, {
  id: 's2',
  name: 'Praxis Schlossplatz',
  address: 'Königstraße 1',
  city: '70173 Stuttgart',
  phone: '0711 998877',
  email: 'team@schlossplatz-zahn.de',
  employees: 10,
  territory: 'Süd',
  coordinates: {
    x: 45,
    y: 60
  }
}, {
  id: 's3',
  name: 'Franken Dental',
  address: 'Königstraße 55',
  city: '90402 Nürnberg',
  phone: '0911 445566',
  email: 'servus@franken-dental.de',
  employees: 7,
  territory: 'Süd',
  coordinates: {
    x: 55,
    y: 58
  }
}, {
  id: 's4',
  name: 'Schwarzwald Lächeln',
  address: 'Kaiser-Joseph-Straße 200',
  city: '79098 Freiburg',
  phone: '0761 223344',
  email: 'info@freiburg-zahn.de',
  employees: 5,
  territory: 'Süd',
  coordinates: {
    x: 38,
    y: 68
  }
}];
export function TerritoryMap() {
  return <div className="relative w-full h-[600px] bg-slate-50 rounded-xl overflow-hidden border border-slate-200" data-id="element-102">
      {/* Legend */}
      <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-4 rounded-lg shadow-sm border border-slate-200 z-20" data-id="element-103">
        <h4 className="text-xs font-semibold text-slate-500 uppercase mb-3" data-id="element-104">
          Vertriebsgebiete
        </h4>
        <div className="space-y-2" data-id="element-105">
          <div className="flex items-center gap-2" data-id="element-106">
            <div className="w-3 h-3 rounded-full bg-blue-500" data-id="element-107"></div>
            <span className="text-sm font-medium text-slate-700" data-id="element-108">Nord</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-109">
            <div className="w-3 h-3 rounded-full bg-teal-500" data-id="element-110"></div>
            <span className="text-sm font-medium text-slate-700" data-id="element-111">Mitte</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-112">
            <div className="w-3 h-3 rounded-full bg-amber-500" data-id="element-113"></div>
            <span className="text-sm font-medium text-slate-700" data-id="element-114">Süd</span>
          </div>
        </div>
      </div>

      {/* Map Container - Larger and Scrollable */}
      <div className="w-full h-full overflow-auto p-4 md:p-8" data-id="element-115">
        <div className="relative w-full min-w-[800px] h-[900px] mx-auto" data-id="element-116">
          {/* Germany Map Image Background */}
          <img src="https://cdn.magicpatterns.com/uploads/dFu2jPnJgcDptsiZKEPRsq/pasted-image.jpg" alt="Karte von Deutschland mit Bundesländern" className="w-full h-full object-contain drop-shadow-xl rounded-lg" data-id="element-117" />

          {/* Pins Layer */}
          <div className="absolute inset-0" data-id="element-118">
            {mockPractices.map(practice => <PracticePin key={practice.id} practice={practice} data-id="element-119" />)}
          </div>
        </div>
      </div>
    </div>;
}